import { tw } from "@/utils";
import { ktasBgColors } from "../styles";
import { Ktas } from "./types";

interface PreKtasLabelProps {
  preKtas: Ktas;
}

export const PreKtasLabel = (props: PreKtasLabelProps) => {
  const { preKtas } = props;

  return (
    <div
      className={tw(
        ktasBgColors[preKtas],
        "flex items-center justify-center",
        "w-[80px] h-[24px] ml-auto rounded-[8px]",
        "text-xs font-semibold text-white"
      )}
    >
      {`Pre-KTAS ${preKtas}`}
    </div>
  );
};
